module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Peter Robinson Leaver was born in 1946 and was educated at Queen Elizabeth’s Grammar School in Blackburn, Lancashire. He subsequently attained a BSc in Earth and Environmental Sciences with the Open University whilst enjoying a career in the Ministry of Defence working with all three-armed services. He fell in love with Gibraltar during a bird-surveying expedition with the RAF, observing migrating birds of prey as they crossed over from Africa. He returned on several occasions to research material for "), _c('em', [_vm._v("Siege XV")]), _vm._v(" and began writing as a hobby. Now retired from his ‘proper job’, Peter works part-time for a national wine company, enjoying the fruits of his labours. He is unmarried and lives in the Wiltshire countryside but remains a passionate Blackburn Rovers fan.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe9e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0